<template>
  <div class="serviceLeagueForm">
    <div class="serviceLeagueForm-t">
      <img :src="detail.picture" alt="" />
    </div>
    <div class="serviceLeagueForm-b">
      <div class="box">
        <div class="name">{{ detail.name }}</div>
        <div class="main">
          <div class="title">简介</div>
          <div class="body">{{ detail.description }}</div>
        </div>
        <div class="main">
          <div class="title">联系方式</div>
          <div class="link">
            <div class="item">
              <div class="item-l">姓名：</div>
              <div class="item-r">{{ detail.contactName }}</div>
            </div>
            <div class="item" @click="toAlink">
              <div class="item-l">电话：</div>
              <div class="item-r">{{ detail.contactMobile }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLeagueDetailURL } from "./api.js";
import { gloabalCount } from "@/utils/common";
export default {
  name: "serviceLeagueForm",
  data() {
    return {
      detail: {},
      bannerList: [],
      id: "",
    };
  },
  components: {},
  destroyed() {},
  computed: {
    communityId() {
      return this.$store.state.communityId;
    },
    userId() {
      return this.$store.state.userId;
    },
    roomId() {
      return this.$store.state.houseId;
    },
    tenantId() {
      return this.$store.state.tenantId;
    },
    openId() {
      return this.$store.state.openId;
    },
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.getTalentDetailList();
    gloabalCount(this.id, 39, 1);
  },
  methods: {
    toAlink(item) {
      window.location.href = `tel://${this.detail.contactMobile}`;
    },
    getTalentDetailList() {
      let params = {
        id: this.id,
      };
      this.$axios
        .get(`${getLeagueDetailURL}`, { params: params })
        .then((res) => {
          console.log(res, 333);
          if (res.code === 200) {
            this.detail = res.data;
          } else {
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.serviceLeagueForm {
  background: #fafafa;
  min-height: 100vh;
  .serviceLeagueForm-t {
    height: 392px;
    width: 100%;
    padding: 34px 30px 28px;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 100%;
      border-radius: 12px;
    }
  }
  .serviceLeagueForm-b {
    padding: 0 30px;
    box-sizing: border-box;
    .box {
      background: #ffffff;
      box-shadow: 0px 4px 16px 0px rgba(227, 227, 227, 0.5);
      border-radius: 16px;
      min-height: 578px;
      padding: 30px;
      box-sizing: border-box;
      .name {
        font-size: 40px;
        font-weight: 600;
        color: #000000;
        line-height: 56px;
        margin-bottom: 44px;
      }
      .main {
        .title {
          margin-bottom: 6px;
          font-size: 28px;
          font-weight: 600;
          color: #615dff;
        }
        .body {
          font-size: 24px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 36px;
        }
        .link {
          .item {
            display: flex;
            font-size: 28px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 40px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.createWorkTalentDetail {
}
</style>
